import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddServiceLayer from "../components/AddServiceLayer";

const AddServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service Add' />

        {/* AddBlogLayer */}
        <AddServiceLayer />
      </MasterLayout>
    </>
  );
};

export default AddServicePage;
